<template>

    <a-drawer placement="right" :closable="false" :visible="visible" @close="close" :width="drawerW">
        <div ref="topRef"></div>
        <div class="header-top">
            <b>课节总结</b>
            <a class="close" @click="close">
                <img src="../../../../public/close.png" />
            </a>
        </div>
        <div class="schedule" v-if="!loading">
            <div>
                <div class="p8">
                    <div class="box" :class="`bg${courseType}`">
                        <div class="time borderb">{{ classInfo.attendDate }} {{ classInfo.classTime }}</div>
                        <div class="p16">
                            <p><b>{{ classInfo.className }}</b></p>
                            <p>{{ classInfo.courseName }}</p>
                            <p>{{ classInfo.placeName || '暂未设置教室' }}</p>
                        </div>
                    </div>
                    <div class="box">
                        <div class="p16 borderb"><b>签到记录</b></div>
                        <div class="checkins">
                            <div v-if="!(checkList && checkList.length)">未签到</div>
                            <div class="records" v-for="item in checkList" :key="item.teacherId">
                                <img :src="item.imgUrl" v-if="item.imgUrl">
                                <img src="../../../../public/defaultAvatar.png" v-else>
                                <div>
                                    {{ item.name }}{{ item.teacherType ? '(' + item.teacherType + ')' : '' }}，在{{
                                        item.time }}，{{ item.status == -1 ? '异常签到' : item.status == 0 ?
                                        '未签到' :
                                        item.status == 1
                                            ? '已签到' : '请假' }}
                                    <span v-if="item.checkInType">(课节码)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="p16 borderb"><b>出勤汇总</b></div>
                        <div class="dfsb  p16">
                            <div>
                                <div class="df">
                                    <div class="w100">
                                        <b>{{ attendanceSummary.shouldCount }}</b>
                                        <p>应出勤人数</p>
                                    </div>
                                    <div class="w100">
                                        <b>{{ attendanceSummary.hasCheckinCount }}</b>
                                        <p>已出勤人数</p>
                                    </div>
                                </div>
                                <div class="h20"></div>
                                <div class="df">
                                    <div class="w100">
                                        <b>{{ attendanceSummary.noCheckinCount }}</b>
                                        <p>缺勤人数</p>
                                    </div>
                                    <div class="w100">
                                        <b>{{ attendanceSummary.leaveCount }}</b>
                                        <p>请假人数</p>
                                    </div>
                                </div>
                            </div>
                            <div class="progress">
                                <a-progress type="circle" :percent="attendanceSummary.attendance" strokeColor='#41cb9a'
                                    :strokeWidth="10" :width="102" />
                                <div class="rate-text">
                                    <p>{{ attendanceSummary.attendance }}%</p>
                                    <p>出勤率</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box p16" v-if="!commentLevel">
                        <b>主讲老师未提交课后总结</b>
                    </div>
                </div>
                <div class="search-box">
                    <a-input v-model="studentName" placeholder="搜索学员" @change="searchStudent">
                        <a-icon slot="prefix" type="search" />
                    </a-input>
                </div>
                <div class="student-box" v-for="item in searchStudentList" :key="item.id">
                    <div class="df">
                        <div class="avatar">
                            <img :src="item.imgUrl" v-if="item.imgUrl">
                            <img src="../../../../public/defaultAvatar.png" v-else>
                        </div>
                        <div class="ellipsis" :title="item.studentName">{{ item.studentName }}</div>
                    </div>
                    <div class="ellipsis" :title="item.originalClassName">{{ item.originalClassName }}</div>
                    <div class="status df" :class="`status${item.checkStatus}`">
                        <span style="margin-right: 20px;">
                            {{ item.checkStatus == 1 ? '已出勤' : item.checkStatus == 2 ? '已请假' : item.checkStatus == 3 ?
                                '未出勤'
                                : '' }}
                        </span>
                        <a-dropdown :trigger="['click']" v-if="item.afterYesterday">
                            <a>
                                修改<a-icon type="down" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item v-for="(item2, index) in studentStatus" :key="index">
                                    <a @click="changeStatus(item, item2)">{{ item2.label }}</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                </div>
                <div v-if="!searchStudentList.length" style="margin-top: 45px;color: #8d9093;">
                    <a-empty description="当前课节未进行考勤点名，无出勤记录"></a-empty>
                </div>
            </div>
            <div class="p8" v-if="commentLevel">
                <div class="box df teacher">
                    <div class="avatar">
                        <img :src="mainTeacher.imgUrl" v-if="mainTeacher.imgUrl">
                        <img src="../../../../public/defaultAvatar.png" v-else>
                    </div>
                    <div style="flex: 1;">
                        <p>{{ mainTeacher.name }}，主讲老师</p>
                        <p>在{{ mainTeacher.submitTime }}提交</p>
                    </div>
                </div>
                <div class="box p16" v-if="scheduleContent">
                    <div class="dfsb box-title">教学内容</div>
                    <div class="box-content">{{ scheduleContent }}</div>
                </div>
                <div class="box evaluate p16">
                    <div class="dfsb box-title">课程表现</div>
                    <div class="df mg-18" :class="{ 'level1': commentLevel == 1, 'level2': commentLevel == 2 }">
                        <img mode="widthFix" v-if="commentLevel == 3" src="../../../../public/operation/good.png" />
                        <img mode="widthFix" v-if="commentLevel == 2" src="../../../../public/operation/general.png" />
                        <img mode="widthFix" v-if="commentLevel == 1" src="../../../../public/operation/bad.png" />
                        {{ commentLevel == 1 ? '表现一般，需要努力！' : commentLevel == 2 ? '表现良好，继续加油！' : '表现优秀，值得鼓励！' }}
                    </div>
                    <div class="box-content">{{ commentContent }}</div>
                </div>
                <div class="box p16" v-if="imgs.length">
                    <div class="dfsb box-title">
                        精彩瞬间
                        <span style="font-weight: normal;font-size: 14px;">共计{{ imgs.length }}张</span>
                    </div>
                    <div class="img-box">
                        <div class="img" v-for="(item, index) in imgs" :key="index">
                            <a><img :src="item" mode="aspectFill" @click="preview(item)"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="loading" v-else><a-spin></a-spin></div>
        <previewImg v-if="showPreview" @closePreview="closePreview" :img="previewUrl"></previewImg>
    </a-drawer>
</template>

<script>
import dayjs from 'dayjs';
import education from '../../../api/education'
import student from '../../../api/student'
import previewImg from "../../../components/previewImg/previewImg.vue";
const studentStatus = [
    { label: '已出勤', value: 1 },
    { label: '已请假', value: 2 },
    { label: '未出勤', value: 3 },
]
export default {
    name: 'classSummary',
    data() {
        return {
            classInfo: {},
            mainTeacher: {},
            scheduleContent: '',
            commentLevel: '',
            commentContent: '',
            imgs: [],
            studentName: '',
            searchText: '',
            searchStudentList: [],
            drawerW: 415,
            courseType: 1,
            checkList: [],
            attendanceSummary: {},
            showPreview: false,
            previewUrl: '',
            studentStatus,
            scheduleId: null,
            loading: false
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        previewImg
    },
    created() {
    },
    methods: {
        getSummary(id, update) {
            if (!id) {
                this.$message.warn('未开课无法查看课节总结')
                this.close()
                return
            } else {
                this.scheduleId = id
            }
            this.loading = true
            education.getScheduleDetail({ scheduleId: this.scheduleId }).then(res => {
                let teaAfterclassReportDo = res.data.teaAfterclassReportDo
                let scheduleInfoDto = res.data.scheduleInfoDto
                if (update) {
                    this.searchStudentListCopy = JSON.parse(JSON.stringify(scheduleInfoDto.studentRollCallDtos))
                    if (this.searchText) {
                        this.searchStudentList = this.searchStudentListCopy.filter(item => item.studentName.includes(this.searchText))
                    } else {
                        this.searchStudentList = scheduleInfoDto.studentRollCallDtos
                    }
                    this.searchStudentList.forEach(item => {
                        const yesterday = dayjs().subtract(1, 'day').startOf('day')
                        item.afterYesterday = dayjs(item.attendDate).isAfter(yesterday) || dayjs(item.attendDate).isSame(yesterday)
                    })
                    this.attendanceSummary = scheduleInfoDto.attendanceSummary
                    this.attendanceSummary.attendance = Number(this.attendanceSummary.attendance)
                    this.loading = false
                    return
                }
                if (teaAfterclassReportDo) {
                    if (teaAfterclassReportDo.commentLevel) this.drawerW = 815
                    this.imgs = teaAfterclassReportDo.commentImages ? teaAfterclassReportDo.commentImages.split(",") : '';
                    this.commentLevel = teaAfterclassReportDo.commentLevel
                    this.commentContent = teaAfterclassReportDo.commentContent
                    this.scheduleContent = teaAfterclassReportDo.scheduleContent
                }
                this.checkList = scheduleInfoDto.checkinRecords
                if (this.checkList) {
                    this.checkList.forEach(item => {
                        item.time = dayjs(item.gmtTime).format('MM-DD HH:mm')
                    })
                    if (this.commentLevel) {
                        this.$nextTick(() => {
                            this.mainTeacher = this.checkList.filter(item => item.teacherId == teaAfterclassReportDo.teacherUserId)[0]
                            let gmtCreate = dayjs(teaAfterclassReportDo.gmtCreate)
                            this.mainTeacher.submitTime = gmtCreate.format('YYYY-MM-DD') != dayjs().format('YYYY-MM-DD') ? gmtCreate.format('YYYY-MM-DD HH:mm:ss') : gmtCreate.format('HH:mm:ss')
                        })
                    }
                }
                this.searchStudentList = scheduleInfoDto.studentRollCallDtos
                this.searchStudentListCopy = JSON.parse(JSON.stringify(scheduleInfoDto.studentRollCallDtos))
                this.searchStudentList.forEach(item => {
                    const yesterday = dayjs().subtract(1, 'day').startOf('day')
                    item.afterYesterday = dayjs(item.attendDate).isAfter(yesterday) || dayjs(item.attendDate).isSame(yesterday)
                })
                this.attendanceSummary = scheduleInfoDto.attendanceSummary
                this.attendanceSummary.attendance = Number(this.attendanceSummary.attendance)
                this.classInfo = scheduleInfoDto.scheduleSourcesDto
                this.classInfo.attendDate = dayjs(this.classInfo.attendDate).format('YYYY-MM-DD')
                this.loading = false
                this.$nextTick(() => {
                    this.$refs.topRef.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                })
            });
        },
        close() {
            this.$emit("update:visible", false);
            this.commentLevel = 0
            this.mainTeacher = {}
            this.commentContent = {}
            this.scheduleContent = {}
            this.drawerW = 415
        },
        searchStudent(e) {
            this.searchText = e.target.value
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.searchStudentList = this.searchStudentListCopy.filter(item => item.studentName.includes(e.target.value))
            }, 300);
        },
        changeStatus(item, item2) {
            console.log(item, item2)
            if (item.checkStatus == item2.value) return
            student.updateCheckin(`${this.scheduleId}:${item.id}`, { status: item2.value }).then(res => {
                this.getSummary(this.scheduleId, true)
                this.$message.success('修改成功')
            })
        },
        preview(url) {
            this.previewUrl = url
            this.showPreview = true
        },
        closePreview() {
            this.showPreview = false
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .ant-drawer-body {
    padding: 0px;
}

.loading {
    height: calc(100vh - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.header-top {
    position: sticky;
    top: 0;
    right: 0;
    z-index: 999;
    line-height: 18px;
    padding: 21px 24px 16px;
    background-color: #f1fafc;
    color: #333;
    font-size: 16px;

    .close {
        position: absolute;
        right: 20px;
        top: 20px;

        img {
            width: 20px;
            height: 20px;
        }
    }
}

.schedule {
    display: flex;
    color: #333;

    .p8 {
        width: 400px;
        padding: 8px;
        // background: url(../../../public/bgImg.png) no-repeat;
    }

    .box {
        border: 1px solid #D8ECFF;
        background-color: #fff;
        margin-bottom: 12px;
        border-radius: 10px;
        width: 100%;
    }

    .time {
        padding: 12px 16px;
        font-size: 16px;
        color: #3c454c;
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;
    }

    .borderb {
        border-bottom: 1px solid rgba(126, 134, 142, 0.16)
    }

    .bg1 {
        background: url('../../../../public/bgImg1@2x.png') right top / cover no-repeat #fff;
    }

    .bg2 {
        background: url('../../../../public/bgImg2@2x.png') right top / cover no-repeat #fff;
    }

    .bg3 {
        background: url('../../../../public/bgImg3@2x.png') right top / cover no-repeat #fff;
    }

    .p16 {
        padding: 16px;

        p {
            line-height: 24px;
        }
    }

    .checkins {
        padding: 16px 16px 10px;

        .records {
            display: flex;
            align-items: center;
            margin-bottom: 6px;

            img {
                width: 24px;
                height: 24px;
                border-radius: 50%;
            }

            div {
                margin-left: 10px;
            }
        }
    }
}

.dfsb {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

::v-deep .ant-progress-text {
    display: none;
}

.df {
    display: flex;
    align-items: center;
}

.w100 {
    width: 100px;
    height: 50px;

    b {
        font-size: 24px;
        line-height: 33px;
    }

    p {
        color: #8d9093;
        font-size: 12px;
        line-height: 14px !important;
    }
}

.progress {
    position: relative;

    .rate-text {
        position: absolute;
        width: 60px;
        top: 33px;
        right: 21px;
        text-align: center;
        color: #8d9093;

        p {
            line-height: 18px;
        }
    }
}

.search-box {
    height: 60px;
    padding: 14px 16px;
    background-color: #fff;
    box-shadow: 0 3px 5px 1px #f2f2f2;

    ::v-deep .ant-input {
        background-color: #eaeced;
        border: none;
    }
}

.student-box {
    border-bottom: 1px solid #f6f7f8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 0 16px;
    line-height: 21px;
    height: 64px;
}

.avatar {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 50%;
    margin-right: 12px;
    display: flex;

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
}

.status {
    min-width: 102px;
    justify-content: flex-end;
}

.status1 {
    color: #4dbc2c;
}

.status2 {
    color: #ff9200;
}

.status3 {
    color: #ff4647;
}

.teacher {
    padding: 8px 16px;

    p {
        flex: 1;
    }
}

.box-title {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}

.box-content {
    color: #3D3D3D;
    font-weight: normal;
    font-size: 14px;
    white-space: pre-wrap;
}

.evaluate {
    color: #FF7300;
    font-weight: bold;
    font-size: 16px;

    img {
        margin-right: 22px;
        width: 84px;
    }
}

.mg-18 {
    margin: 18px 0;
}

.level1 {
    color: #acbbdd;
}

.level2 {
    color: #fec889;

    img {
        width: 60px;
        height: 60px;
    }
}

.img-box {
    margin-top: 18px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .img {
        width: 112px;
        height: 112px;
        border-radius: 6px;
        margin-right: 7px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            object-fit: cover;
        }
    }

    .img:nth-child(3n) {
        margin-right: 0;
    }

    .img:nth-child(n+4) {
        margin-top: 7px;
    }
}

.h20 {
    height: 20px;
}

.ellipsis {
    font-size: 14px;
    width: 100px;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 100px !important;
}
</style>